import { Draggable, SelectBox, Switch, TextArea } from 'devextreme-react'
import React, { useCallback, useEffect, useState } from 'react'
import { Info } from 'react-feather'
import { toast } from 'react-toastify'
import { Alert, Button, Col, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap'
import api from '../../../services/api-configuration'
import useFormatMessage from '../../../utils/useFormatMessage'

const DepoEkle = ({ selected, isOpen, setIsOpen, setTrigger, trigger }) => {
    useEffect(() => {
        fetchILData()
        fetchAddressData()
    }, [])

    const { t } = useFormatMessage()
    const [city, setCity] = useState([])
    const [addresses, setAddresses] = useState([])

    const notifyError = (message) => toast.error(message)
    const notifySuccess = (message) => toast.success(message)

    const InputCode = ({ title, id, children, type, value, disabled }) => {
        return (<Col lg="12">
            <div className="dx-fieldset p-0 m-1">
                <div className="dx-field">
                    <div className="dx-field-label" style={{ color: "black" }}>{t(title)}</div>
                    <div className="dx-field-value d-flex">
                        {children ? children : <Input id={id} type={type ? type : "text"}
                            disabled={disabled ? disabled : false}
                            defaultValue={selected[value]}
                            min={type === "number" ? 0 : null}
                            placeholder={`${t('please')} ${t(title)} ${t('enter')} ...`}
                        />}
                    </div>
                </div>
            </div>
        </Col>)
    }

    const fetchILData = async () => {
        try {
            const response = await api.post("/city/getAll");
            setCity(response.data.data || []);
        } catch (error) {
            toast.error("Hata oluştu");
            console.error("Error fetching cities:", error);
        }
    };

    const fetchAddressData = async () => {
        try {
            const response = await api.post("/prmAddress/getAll");
            setAddresses(response.data.data || []);
        } catch (error) {
            toast.error("Hata oluştu");
            console.error("Error fetching addresses:", error);
        }
    };

    const formatAddress = useCallback((item) => {
        if (!item) return '';
        return `${item.neighborhood}|${item.street}|${item.address}|${item.building_no}|${item.district_name}|${item.city_name}`;
    }, []);

    const validateObject = () => {
        var result = true;
        if (document.getElementById("depo-kodu").value === "") {
            notifyError(t("Depo Kodu") + " " + t("Boş Olamaz"))
            result = false;
            return
        }
        if (document.getElementById("depo-adi").value === "") {
            notifyError(t("Depo Adı") + " " + t("Boş Olamaz"))
            result = false;
            return
        }
        if (document.getElementById("depo-kisa-adi").value === "") {
            notifyError(t("Depo Kısa Adı") + " " + t("Boş Olamaz"))
            result = false;
            return
        }
        if (document.getElementById("kapasite").value === "") {
            notifyError(t("Kapasite") + " " + t("Boş Olamaz"))
            result = false;
            return
        }
        if (document.getElementById("address").childNodes[0].childNodes[0].value === "") {
            notifyError(t("Adres") + " " + t("Boş Olamaz"))
            result = false;
            return
        }
        return result;
    }

    const WarehousChange = (type) => {
        if (validateObject()) {
            let API = type === "add" ? '/warehouse/add' : '/warehouse/update'
            var addBody = {
                "address_id": parseInt(document.getElementById("address").childNodes[0].childNodes[0].value),
                "address_description": document.getElementById("adres-tarifi").childNodes[0].childNodes[0].childNodes[0].value,
                "capacity": parseInt(document.getElementById("kapasite").value),
                "create_user_id": parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii')),
                "is_active": document.getElementById("gecerli").childNodes[1].value === "true" ? true : false,
                "tax_number": document.getElementById("vergi-no").value,
                "tax_office": document.getElementById("vergi-dairesi").value,
                "warehouse_code": document.getElementById("depo-kodu").value,
                "city_id": parseInt(document.getElementById("il-select").childNodes[0].childNodes[0].value),
                "warehouse_description": "",
                "warehouse_name": document.getElementById("depo-adi").value,
                "warehouse_short_name": document.getElementById("depo-kisa-adi").value,
                "discharge_area_status": document.getElementById("tahliye_Acik").childNodes[1].value === "true" ? true : false,
                "standard_address_id": parseInt(document.getElementById("address").value),
                "hal_type": document.getElementById("hal-type").childNodes[0].childNodes[0].value ? parseInt(document.getElementById("hal-type").childNodes[0].childNodes[0].value) : null,
                "origin_cedi": document.getElementById("origin-cedi").value || null
            }
            var updateBody = {
                "address_id": parseInt(document.getElementById("address").childNodes[0].childNodes[0].value),
                "address_description": document.getElementById("adres-tarifi").childNodes[0].childNodes[0].childNodes[0].value,
                "capacity": parseInt(document.getElementById("kapasite").value),
                "id": selected.id,
                "city_id": parseInt(document.getElementById("il-select").childNodes[0].childNodes[0].value),
                "is_active": document.getElementById("gecerli").childNodes[1].value === "true" ? true : false,
                "tax_number": document.getElementById("vergi-no").value,
                "tax_office": document.getElementById("vergi-dairesi").value,
                "update_user_id": parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii')),
                "warehouse_name": document.getElementById("depo-adi").value,
                "warehouse_short_name": document.getElementById("depo-kisa-adi").value,
                "discharge_area_status": document.getElementById("tahliye_Acik").childNodes[1].value === "true" ? true : false,
                "standard_address_id": parseInt(document.getElementById("address").value),
                "hal_type": document.getElementById("hal-type").childNodes[0].childNodes[0].value ? parseInt(document.getElementById("hal-type").childNodes[0].childNodes[0].value) : null,
                "origin_cedi": document.getElementById("origin-cedi").value || null
            }
            const response = api.post(API, type === "add" ? addBody : updateBody)
            response.then((res) => {
                document.getElementById("save-button").disabled = false;
                document.getElementById("cancel-button").disabled = false;

                notifySuccess(t(`Depo ${type === "add" ? "Ekleme" : "Güncelleme"} Başarılı`))
                setTrigger(!trigger)
                setIsOpen(!isOpen)

            }).catch((err) => {
                document.getElementById("save-button").disabled = false;
                document.getElementById("cancel-button").disabled = false;
                let errorMessage = err.response.data.error
                notifyError(t(`Depo ${type === "add" ? "Ekleme" : "Güncelleme"} Başarısız`) + " : " + t(errorMessage))
                console.error(err)
            })
        } else {
            document.getElementById("save-button").disabled = false;
            document.getElementById("cancel-button").disabled = false;
        }
    }

    return (
        <Draggable handle='.modal-header'>
            <Modal size='lg' isOpen={isOpen} toggle={() => setIsOpen(!isOpen)} >
                <ModalHeader className='modal-header' toggle={() => setIsOpen(!isOpen)}>{t("Depo Ekle")}</ModalHeader>
                <ModalBody>
                    <Row>
                        <InputCode title="Depo Kodu" disabled={true} id="depo-kodu" value={"warehouse_code"} />
                        <InputCode title="İl"  >
                            <SelectBox
                                id='il-select'
                                className='w-100'
                                dataSource={city}
                                valueExpr="id"
                                displayExpr={(c) => (c ? `${c.city_name} (${c.country_code})` : '')}
                                placeholder={t("Lütfen İl Seçiniz") + " ..."} />
                        </InputCode>
                        <InputCode title="Depo Adı" id="depo-adi" value={"warehouse_name"} />
                        <InputCode title="Depo Kısa Adı" id="depo-kisa-adi" value={"warehouse_short_name"} />
                        <InputCode title="Kapasite" id="kapasite" type={"number"} value={"capacity"} />
                        <InputCode title="Adres" id="address">
                            <SelectBox
                                id='address'
                                className='w-100'
                                dataSource={addresses}
                                valueExpr="id"
                                displayExpr={formatAddress}
                                defaultValue={selected?.address_id}
                                placeholder={t("Lütfen Adres Seçiniz") + " ..."}
                                searchEnabled={true}
                            />
                        </InputCode>
                        <InputCode title="Adres Tarifi" id="adres-tarifi" >
                            <TextArea defaultValue={selected?.address_description} id="adres-tarifi" className='w-100' placeholder={t("Lütfen Adres Tarifi Giriniz") + " ..."}
                            />
                        </InputCode>
                        <InputCode title="Vergi Dairesi" id="vergi-dairesi" value={"tax_office"} />
                        <InputCode title="Vergi No" id="vergi-no" value={"tax_number"} />
                        <InputCode title="HAL OC Type" id="hal-type">
                            <SelectBox
                                id='hal-type'
                                className='w-100'
                                dataSource={[
                                    { name: "Sevk Emri", id: 1 },
                                    { name: "Grupaj", id: 2 }
                                ]}
                                valueExpr="id"
                                displayExpr="name"
                                defaultValue={selected?.hal_type}
                                placeholder={t("Lütfen HAL OC Type Seçiniz") + " ..."}
                                showClearButton={true}
                            />
                        </InputCode>
                        <InputCode title="Origin CEDI" id="origin-cedi" value={"origin_cedi"} />

                        <InputCode title="Geçerli" id="gecerli" >
                            <Switch defa id="gecerli" defaultValue={selected?.is_active} width={100}
                                switchedOnText={t("Evet")} switchedOffText={t("Hayır")} />
                        </InputCode>

                        <InputCode title="Tahliyeye Açık Bölge" id="tahliye_acik" >
                            <Switch id="tahliye_Acik" defaultValue={false} width={100}
                                switchedOnText={t("Evet")} switchedOffText={t("Hayır")}
                            />
                        </InputCode>
                    </Row>
                    <Row>
                        <Alert className="mt-2" variant="warning"
                            color='warning'
                            style={{ color: "#3d3d3d" }}
                        >
                            <Info className="h-4 w-4" />&nbsp;
                            Bu depo altında en az bir PERON tipinde bölge tanımlanmalı ve bu PERON bölgesinin altına PP-999 adresi eklenmelidir.
                            PP-999 adresi, çoklu depo grupaj operasyonlarında ortak sevkiyat noktası olarak kullanılır.
                        </Alert>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button id='save-button' color="secondary" onClick={() => {
                        document.getElementById("save-button").disabled = true;
                        document.getElementById("cancel-button").disabled = true;
                        WarehousChange(
                            selected.id ? "update" : "add"
                        )
                    }}>{t("Kaydet")}</Button>{' '}
                    <Button id='cancel-button' color="danger" onClick={() => setIsOpen(!isOpen)}>{t("İptal")}</Button>
                </ModalFooter>
            </Modal>
        </Draggable>
    )
}

export default DepoEkle